module.exports = __webpack_public_path__ + "static/media/gray.0119d2b4.png";